import * as R from 'ramda';
import router from '@/router';
import { clientsListingService } from './client-details.service';
import {
  ClientDetailsActions,
  ClientDetailsGetters,
  ClientsDetailsMutations
} from './client-details.keys';
import { attachmentService } from '../../../../components/attachments/attachment.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';
export const getInitialState = () => {
  return {
    currentClientDetails: {
      client: {},
      address: [],
      contacts: [],
      billingMethods: []
    },
    billingIsLoading: true,
    billingRecordsCount: 10,
    clientDetailsBillingPaginationParameters: {
      billingRecordsPerPage: 10,
      billingRecordsOffset: 0
    },
    contactsIsLoading: true,
    contactsRecordsCount: 10,
    clientDetailsContactsPaginationParameters: {
      contactsRecordsPerPage: 10,
      contactsRecordsOffset: 0
    },
    clientReferenceNumber: '',
    searchParam: '',
    clientAttachments: [],
    clientDetailsHistories: []
  };
};
export const clientDetailsStore = {
  state: getInitialState,
  getters: {
    [ClientDetailsGetters.GetClientDetails]: state => state.currentClientDetails.client,
    [ClientDetailsGetters.GetClientDetailsAddressList]: state => state.currentClientDetails.address,
    [ClientDetailsGetters.GetClientDetailsReferenceNumber]: state => state.clientReferenceNumber,
    // Client Details Contacts List & Pagination Params
    [ClientDetailsGetters.GetClientDetailsContactsList]: state =>
      state.currentClientDetails.contacts,
    [ClientDetailsGetters.GetClientDetailsContactsRecordsPerPage]: state =>
      state.clientDetailsContactsPaginationParameters.contactsRecordsPerPage,
    [ClientDetailsGetters.GetClientDetailsContactsRecordsOffset]: state =>
      state.clientDetailsContactsPaginationParameters.contactsRecordsOffset,
    [ClientDetailsGetters.GetClientDetailsContactsRecordsCount]: state =>
      state.contactsRecordsCount,
    [ClientDetailsGetters.GetClientDetailsContactsIsLoading]: state => state.contactsIsLoading,
    // Client Details Billing Methods List & Pagination Params
    [ClientDetailsGetters.GetClientDetailsBillingMethodsList]: state =>
      state.currentClientDetails.billingMethods,
    [ClientDetailsGetters.GetClientDetailsBillingRecordsCount]: state =>
      parseInt(state.billingRecordsCount),
    [ClientDetailsGetters.GetClientDetailsBillingRecordsOffset]: state =>
      state.clientDetailsBillingPaginationParameters.billingRecordsOffset,
    [ClientDetailsGetters.GetClientDetailsBillingRecordsPerPage]: state =>
      state.clientDetailsBillingPaginationParameters.billingRecordsPerPage,
    [ClientDetailsGetters.GetClientDetailsBillingIsLoading]: state => state.billingIsLoading,
    [ClientDetailsGetters.GetClientDetailsHistories]: state => state.clientDetailsHistories,
    [ClientDetailsGetters.GetClientAttachments]: state => state.clientAttachments
  },
  mutations: {
    [ClientsDetailsMutations.SetClientDetails](state, clientDetails) {
      state.currentClientDetails = {
        client: clientDetails.client,
        address: clientDetails.address,
        contacts: clientDetails.contacts,
        billingMethods: clientDetails.billingMethods
      };
    },
    [ClientsDetailsMutations.SetClientDetailsReferenceNumber](state, referenceNumber) {
      state.clientReferenceNumber = referenceNumber;
    },
    [ClientsDetailsMutations.SetClientDetailsContactsSearchParam](state, searchParam) {
      state.searchParam = searchParam;
    },
    [ClientsDetailsMutations.SetClientDetailsContactsPaginationParameters](
      state,
      paginationParameters
    ) {
      state.clientDetailsContactsPaginationParameters.contactsRecordsPerPage =
        paginationParameters.recordsPerPage;
      state.clientDetailsContactsPaginationParameters.contactsRecordsOffset =
        paginationParameters.offset;
    },
    [ClientsDetailsMutations.SetClientDetailsContactsRecordsCount](state, clientsListCount) {
      state.contactsRecordsCount = clientsListCount;
    },
    [ClientsDetailsMutations.ResetClientDetailsContactsPaginationPropertyOffset](state) {
      state.clientDetailsContactsPaginationParameters.contactsRecordsOffset = 0;
    },
    [ClientsDetailsMutations.SetClientDetailsContactsIsLoading](state, isLoading = true) {
      state.contactsIsLoading = isLoading;
    },
    // Client Details Billing Methods/Pagination Mutations
    [ClientsDetailsMutations.SetClientDetailsBillingPaginationParameters](
      state,
      paginationParameters
    ) {
      state.clientDetailsBillingPaginationParameters.billingRecordsPerPage =
        paginationParameters.recordsPerPage;
      state.clientDetailsBillingPaginationParameters.billingRecordsOffset =
        paginationParameters.offset;
    },
    [ClientsDetailsMutations.SetClientDetailsBillingRecordsCount](state, clientsListCount) {
      state.billingRecordsCount = clientsListCount;
    },
    [ClientsDetailsMutations.ResetClientDetailsBillingPaginationPropertyOffset](state, offset) {
      state.clientDetailsBillingPaginationParameters.billingRecordsOffset = offset;
    },
    [ClientsDetailsMutations.SetClientDetailsBillingIsLoading](state, isLoading = true) {
      state.billingIsLoading = isLoading;
    },
    // Client Details Address and Updates
    [ClientsDetailsMutations.UpdateClientDetails](state, clientDetails) {
      state.currentClientDetails.client = clientDetails;
    },
    [ClientsDetailsMutations.SetClientDetailsAddressList](state, addressList) {
      state.currentClientDetails.address = addressList;
    },
    [ClientsDetailsMutations.RemoveClientDetailsAddress](state, address) {
      state.currentClientDetails.address = state.currentClientDetails.address.filter(
        element => element.id !== address.id
      );
    },
    [ClientsDetailsMutations.UpdateClientDetailsAddress](state, address) {
      state.currentClientDetails.address.forEach((element, index) => {
        if (element.id === address.updateAddress.id) {
          let updatedAddress = address.updateAddress;
          updatedAddress[address.name] = address.value;
          state.currentClientDetails.address[index] = updatedAddress;
        }
      });
    },
    [ClientsDetailsMutations.AddClientDetailsAddress](state, address) {
      state.currentClientDetails.address.push(address);
    },
    [ClientsDetailsMutations.SetClientDetailsContactsList](state, contactsList) {
      state.currentClientDetails.contacts = contactsList;
    },
    [ClientsDetailsMutations.SetClientDetailsBillingMethodsList](state, billingMethodsList) {
      state.currentClientDetails.billingMethods = billingMethodsList;
    },
    [ClientsDetailsMutations.RemoveClientDetailsBillingMethod](state, billingMethod) {
      state.currentClientDetails.billingMethods = state.currentClientDetails.billingMethods.filter(
        element => element.id != billingMethod.id
      );
    },
    [ClientsDetailsMutations.AddClientDetailsBillingMethod](state, billingMethod) {
      state.currentClientDetails.billingMethods.push(R.clone(billingMethod));
    },
    [ClientsDetailsMutations.UpdateClientDetailsBillingMethod](state, billingMethod) {
      state.currentClientDetails.billingMethods.forEach((element, index) => {
        if (element.id === billingMethod.id) {
          state.currentClientDetails.billingMethods[index] = R.clone(billingMethod);
        }
      });
    },
    [ClientsDetailsMutations.UpdateClientDefaultAddress](state, addressId) {
      state.currentClientDetails.client.address_id = addressId;
    },
    [ClientsDetailsMutations.UpdateClientDefaultBillingMethod](state, billingMethodId) {
      state.currentClientDetails.billingMethods.forEach(billingMethod => {
        billingMethod.is_default = billingMethod.id === billingMethodId;
      });
    },
    [ClientsDetailsMutations.ResetClientDetails](state) {
      state.currentClientDetails = getInitialState().currentClientDetails;
    },
    [ClientsDetailsMutations.SetClientDetailsHistories](state, clientDetailsHistories) {
      state.clientDetailsHistories = clientDetailsHistories;
    },
    [ClientsDetailsMutations.SetClientAttachment](state, attachments) {
      state.clientAttachments = attachments;
    }
  },
  actions: {
    [ClientDetailsActions.RetrieveClientDetails]({ state, commit, dispatch }, clientId) {
      clientsListingService
        .getClientDetails(clientId, {
          ...state.clientDetailsBillingPaginationParameters,
          ...state.clientDetailsContactsPaginationParameters,
          searchParam: state.searchParam
        })
        .then(clientDetails => {
          commit(ClientsDetailsMutations.SetClientDetails, clientDetails);
          commit(
            ClientsDetailsMutations.SetClientDetailsBillingRecordsCount,
            clientDetails.billingRecordsCount
          );
          commit(
            ClientsDetailsMutations.SetClientDetailsContactsRecordsCount,
            clientDetails.contactsRecordsCount
          );
          dispatch(ClientDetailsActions.RetrieveClientAttachments, clientId);
          dispatch(ClientDetailsActions.GetClientDetailsHistories, clientId);
        })
        .then(() => {
          commit(ClientsDetailsMutations.SetClientDetailsContactsIsLoading, false);
          commit(ClientsDetailsMutations.SetClientDetailsBillingIsLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },
    [ClientDetailsActions.RetrieveClientContactDetails]({ state, commit }) {
      clientsListingService
        .getClientDetails(state.clientReferenceNumber, {
          ...state.clientDetailsBillingPaginationParameters,
          ...state.clientDetailsContactsPaginationParameters,
          searchParam: state.searchParam
        })
        .then(clientDetails => {
          commit(ClientsDetailsMutations.SetClientDetails, clientDetails);
        });
    },
    [ClientDetailsActions.ClientDetailsContactsSearchUpdate]({ dispatch, commit }, payload) {
      commit(ClientsDetailsMutations.SetClientDetailsContactsSearchParam, payload.searchParam);
      if (payload.isSearchKey) {
        commit(
          ClientsDetailsMutations.SetClientDetailsReferenceNumber,
          payload.data.client.reference_number
        );
        commit(ClientsDetailsMutations.ResetClientDetailsContactsPaginationPropertyOffset);
        commit(ClientsDetailsMutations.SetClientDetailsContactsList, payload.data.contacts);
        commit(
          ClientsDetailsMutations.SetClientDetailsContactsRecordsCount,
          payload.data.contactsRecordsCount
        );
      } else {
        commit(ClientsDetailsMutations.SetClientDetailsContactsPaginationParameters, {
          recordsPerPage: 10,
          offset: 0
        });
        commit(ClientsDetailsMutations.SetClientDetailsContactsSearchParam, '');
        dispatch(ClientDetailsActions.RetrieveClientContactDetails);
      }
    },
    // Client Details Contacts Pagination Update
    [ClientDetailsActions.ClientDetailsContactsPaginationParametersUpdate](
      { dispatch, commit },
      payload
    ) {
      let contactsPaginationParams = payload.paginationParameters;
      commit(
        ClientsDetailsMutations.SetClientDetailsContactsPaginationParameters,
        contactsPaginationParams
      );
      commit(ClientsDetailsMutations.SetClientDetailsContactsIsLoading);
      dispatch(ClientDetailsActions.RetrieveClientDetails, payload.clientRefNum);
    },
    //Client Details Billing Pagination Update
    [ClientDetailsActions.ClientDetailsBillingPaginationParametersUpdate](
      { dispatch, commit },
      payload
    ) {
      let billingPaginationParams = payload.paginationParameters;
      commit(
        ClientsDetailsMutations.SetClientDetailsBillingPaginationParameters,
        billingPaginationParams
      );
      commit(ClientsDetailsMutations.SetClientDetailsBillingIsLoading);
      dispatch(ClientDetailsActions.RetrieveClientDetails, payload.clientRefNum);
    },
    [ClientDetailsActions.RetrieveClientAttachments]: ({ commit }, referenceNumber) => {
      return attachmentService.getAttachments(referenceNumber, 'CLIENT').then(response => {
        commit(ClientsDetailsMutations.SetClientAttachment, response.data);
      });
    },
    [ClientDetailsActions.UpdateClientDetails]({ commit }, clientDetails) {
      commit(ClientsDetailsMutations.UpdateClientDetails, clientDetails);
    },
    [ClientDetailsActions.UpdateClientDetailsAddress]({ commit }, address) {
      commit(ClientsDetailsMutations.UpdateClientDetailsAddress, address);
    },
    [ClientDetailsActions.AddAddress]({ commit }, address) {
      commit(ClientsDetailsMutations.AddClientDetailsAddress, address);
    },
    [ClientDetailsActions.RemoveAddress]({ commit }, address) {
      commit(ClientsDetailsMutations.RemoveClientDetailsAddress, address);
    },
    [ClientDetailsActions.SetClientDetailsContactsList]({ commit }, contactsList) {
      commit(ClientsDetailsMutations.SetClientDetailsContactsList, contactsList);
    },
    [ClientDetailsActions.SetClientDetailsBillingMethodsList]({ commit }, billingMethodsList) {
      commit(ClientsDetailsMutations.SetClientDetailsBillingMethodsList, billingMethodsList);
    },
    [ClientDetailsActions.RemoveClientDetailsBillingMethod]({ commit }, billingMethod) {
      commit(ClientsDetailsMutations.RemoveClientDetailsBillingMethod, billingMethod);
    },
    [ClientDetailsActions.AddClientDetailsBillingMethod]({ commit }, billingMethod) {
      commit(ClientsDetailsMutations.AddClientDetailsBillingMethod, billingMethod);
    },
    [ClientDetailsActions.UpdateClientDetailsBillingMethod]({ commit }, billingMethod) {
      commit(ClientsDetailsMutations.UpdateClientDetailsBillingMethod, billingMethod);
    },
    [ClientDetailsActions.UpdateClientDefaultAddress]({ commit }, addressId) {
      commit(ClientsDetailsMutations.UpdateClientDefaultAddress, addressId);
    },
    [ClientDetailsActions.UpdateClientDefaultBillingMethod]({ commit }, billingMethodId) {
      commit(ClientsDetailsMutations.UpdateClientDefaultBillingMethod, billingMethodId);
    },
    [ClientDetailsActions.GetClientDetailsHistories]({ commit }, clientId) {
      clientsListingService.getClientDetailsHistories(clientId).then(status => {
        commit(ClientsDetailsMutations.SetClientDetailsHistories, status);
      });
    },
    [ClientDetailsActions.SaveClientDetails]({ state, dispatch }, section) {
      clientsListingService.saveClientDetails(state.currentClientDetails, section).then(status => {
        dispatch(TolErrorsActions.ClearAll);
        if (status && status.message === 'success') {
          dispatch(ClientDetailsActions.RetrieveClientDetails, status.data).then(
            router.push({ name: 'client-details', params: { id: status.data } }).catch(() => {})
          );

          if (status.info) {
            dispatch(TolMessagesActions.SetMessages, status.info);
          }
        } else {
          dispatch(TolMessagesActions.ClearAll);
          const messages = Object.values(status.errors);
          let items = [];
          for (let item of messages) {
            items = items.concat(item);
          }
          dispatch(TolErrorsActions.SetError, { items });
        }
      });
    },
    [ClientDetailsActions.ResetClientDetails]({ commit }) {
      commit(ClientsDetailsMutations.ResetClientDetails);
    }
  }
};
